import type { App } from 'vue'

import Recaptcha from './x002-vue-recaptcha'
import Countdown from './x003-vue-countdown'
import ResourceComponents from './resource'
import OtpComponent from './otp/component.vue'

export default {
  install(app: App<Element>): void {
    app
      .use(Recaptcha)
      .use(Countdown)
      .use(ResourceComponents)
      .component('OtpComponent', OtpComponent)
  }
}